import { CheckCircle2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const REQUIRED = ["outlet", "date"];
const NONE = "__none";

export const ColumnMapper = ({ fields, columns, mapping, onChange, sample = [], testid = "column-mapper" }) => {
  const set = (key, col) => {
    const next = { ...mapping };
    if (col === NONE) delete next[key];
    else next[key] = col;
    onChange(next);
  };
  const first = sample[0] || {};
  return (
    <div data-testid={testid} className="grid grid-cols-1 gap-3 md:grid-cols-2">
      {fields.map((f) => {
        const col = mapping[f.key];
        return (
          <div key={f.key} className={`flex flex-col gap-2 rounded-xl border p-3 sm:flex-row sm:items-center ${col ? "border-emerald-200 bg-emerald-50/40" : "border-slate-200 bg-white"}`}>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-1.5 text-sm font-semibold text-slate-800">
                {col && <CheckCircle2 className="h-4 w-4 text-emerald-600" />}
                {f.label}
                {REQUIRED.includes(f.key) && <span className="text-red-500">*</span>}
              </div>
              <div className="truncate text-xs text-slate-500">{col ? `e.g. "${first[col] ?? ""}"` : "Not in this file"}</div>
            </div>
            <Select value={col || NONE} onValueChange={(v) => set(f.key, v)}>
              <SelectTrigger data-testid={`map-${f.key}`} className="h-10 w-full rounded-lg bg-white sm:w-[220px]"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value={NONE}>— Not in file —</SelectItem>
                {columns.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        );
      })}
    </div>
  );
};
